import React from 'react';
import moment from 'moment';
import { Typography, Stack } from '@mui/material';
import { IExperience } from './types';

export default function ExperienceItem({
  company,
  experience
}: {
  company?: string | null;
  experience: IExperience;
}) {
  return (
    <Stack direction="column" spacing={1} sx={{ width: '100%' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="column">
          {company && (
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {company}
            </Typography>
          )}
          {!company && (
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: '#d9d9d9',
                marginLeft: '-33px',
                position: 'absolute',
                fontSize: '25px',
                lineHeight: '25px'
              }}
            >
              •
            </Typography>
          )}
          <Typography variant="body2">{experience.position}</Typography>
        </Stack>
        <Typography variant="body2" sx={{ color: '#858585' }}>
          <span>{moment(experience.started).format('MMM YYYY')}</span>
          <span>{' - '}</span>
          <span>
            {experience.current && !experience.ended
              ? 'Present'
              : moment(experience.ended).format('MMM YYYY')}
          </span>
        </Typography>
      </Stack>
      <Stack direction="column" spacing={1}>
        <Typography variant="body2" sx={{ mb: 1, color: '#858585' }}>
          {experience.location}
        </Typography>
        {experience.summary && experience.summary.length > 0 && (
          <ul style={{ paddingLeft: '24px', listStyle: 'disc' }}>
            {experience.summary.split('\n').map((line, index) => {
              const sanitizedLine = line.replace(/^\s*•\s*/, '');
              return <li key={index}>{sanitizedLine}</li>;
            })}
          </ul>
        )}
      </Stack>
    </Stack>
  );
}
